import { BrowserFourdApi } from '.';
import { document } from '../../api/document';

export class Document implements document.Api {
  constructor(private fourd: BrowserFourdApi) {}

  createDocument(request: document.createDocumentRequest): void {
    this.fourd.call4Dv2('document.createDocument', request);
  }

  createBasedOnDocument(request: document.createBasedOnDocumentRequest): void {
    this.fourd.call4Dv2('document.createBasedOnDocument', request);
  }

  openUserFolder(): void {
    this.fourd.call4Dv2('precedent.openUserFolder');
  }

  hasUserPrecedents(): Promise<document.HasUserPrecedentsResponse> {
    return this.fourd.twoWayCall<void, document.HasUserPrecedentsResponse>(
      null,
      (requestId, request) => {
        this.fourd.call4Dv2('precedent.hasUserPrecedents', request, requestId);
      },
      (response) => response
    );
  }

  uploadLocalFolder(): Promise<document.UploadLocalFolderResponse> {
    return this.fourd.twoWayCall<void, document.UploadLocalFolderResponse>(
      null,
      (requestId, request) => {
        this.fourd.call4Dv2('document.uploadLocalFolder', request, requestId);
      },
      (response) => response
    );
  }

  openFolder(request: document.OpenFolderRequest): void {
    this.fourd.call4Dv2('matter.openFolder', request);
  }

  previewDocument(request: document.PreviewDocumentRequest): void {
    this.fourd.call4Dv2('document.previewDocument', request);
  }

  previewPrecedent(request: document.PreviewPrecedentRequest): void {
    this.fourd.call4Dv2('document.previewPrecedent', request);
  }

  createDocumentFromContainer(request: document.CreateDocumentFromContainerRequest): void {
    this.fourd.call4Dv2('document.createDocumentFromContainer', request);
  }

  createDocumentFromPrecedent(request: document.CreateDocumentFromPrecedentRequest): void {
    this.fourd.call4Dv2('document.createDocumentFromPrecedent', request);
  }

  openDocument(request: document.OpenDocumentRequest): void {
    this.fourd.call4Dv2('document.openDocument', request);
  }

  reloadDocumentList(request: document.ReloadDocumentListRequest): void {
    this.fourd.call4Dv2('document.reloadDocumentList', request);
  }

  editPrecedent(request: document.EditPrecedentRequest): void {
    this.fourd.call4Dv2('document.editPrecedent', request);
  }

  selectPrecedent(request: document.SelectPrecedentRequest): Promise<document.SelectPrecedentResponse> {
    return this.fourd.twoWayCall<document.SelectPrecedentRequest, document.SelectPrecedentResponse>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('document.selectPrecedent', request, requestId);
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          responseData = response;
        }

        if (responseData && typeof responseData === 'object') {
          return this.mapSelectPrecedentResponse(responseData);
        }

        return responseData as document.SelectPrecedentResponse;
      }
    );
  }

  createDocumentBasedOnURL(request: document.CreateDocumentBasedOnURLRequest): void {
    this.fourd.call4Dv2('document.createDocumentBasedOnURL', request);
  }

  private getPropertyCaseInsensitive(obj: any, propertyName: string): any {
    const lowerPropertyName = propertyName.toLowerCase();
    for (const key in obj) {
      if (key.toLowerCase() === lowerPropertyName) {
        return obj[key];
      }
    }

    return undefined;
  }

  private mapSelectPrecedentResponse(responseData: any) {
    const mappedResponse: document.SelectPrecedentResponse = {
      sql: this.getPropertyCaseInsensitive(responseData, 'sql'),
      recordId: this.getPropertyCaseInsensitive(responseData, 'recordId'),
      parentId: this.getPropertyCaseInsensitive(responseData, 'parentId'),
      parentMatterTypeId: this.getPropertyCaseInsensitive(responseData, 'parentMatterTypeId'),
      name: this.getPropertyCaseInsensitive(responseData, 'name'),
      originalName: this.getPropertyCaseInsensitive(responseData, 'originalName'),
      entity: this.getPropertyCaseInsensitive(responseData, 'entity'),
      sortByType: this.getPropertyCaseInsensitive(responseData, 'sortByType'),
      sortOrder: this.getPropertyCaseInsensitive(responseData, 'sortOrder'),
      application: this.getPropertyCaseInsensitive(responseData, 'application'),
      state: this.getPropertyCaseInsensitive(responseData, 'state'),
      hasChild: this.getPropertyCaseInsensitive(responseData, 'hasChild'),
      deleteCode: this.getPropertyCaseInsensitive(responseData, 'deleteCode'),
      documentType: this.getPropertyCaseInsensitive(responseData, 'documentType'),
      code: this.getPropertyCaseInsensitive(responseData, 'code'),
      formNumber: this.getPropertyCaseInsensitive(responseData, 'formNumber'),
      shortcutId: this.getPropertyCaseInsensitive(responseData, 'shortcutId'),
      notification: this.getPropertyCaseInsensitive(responseData, 'notification'),
      precedentType: this.getPropertyCaseInsensitive(responseData, 'precedentType'),
      baseId: this.getPropertyCaseInsensitive(responseData, 'baseId'),
      profileId: this.getPropertyCaseInsensitive(responseData, 'profileId'),
      profileName: this.getPropertyCaseInsensitive(responseData, 'profileName'),
      realClass: this.getPropertyCaseInsensitive(responseData, 'realClass'),
      class: this.getPropertyCaseInsensitive(responseData, 'class'),
      realDeleteCode: this.getPropertyCaseInsensitive(responseData, 'realDeleteCode'),
      realMatterTypeId: this.getPropertyCaseInsensitive(responseData, 'realMatterTypeId'),
      realParentId: this.getPropertyCaseInsensitive(responseData, 'realParentId'),
      realProfileId: this.getPropertyCaseInsensitive(responseData, 'realProfileId'),
      realCode: this.getPropertyCaseInsensitive(responseData, 'realCode'),
      precedentTargetType: this.getPropertyCaseInsensitive(responseData, 'precedentTargetType'),
      url: this.getPropertyCaseInsensitive(responseData, 'url'),
      clonedVersion: this.getPropertyCaseInsensitive(responseData, 'clonedVersion'),
    };
    return mappedResponse;
  }
}
